import React from 'react';

export type FlagSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface FlagProps {
  countryCode: string;
  code?: string;
  size?: FlagSize;
  className?: string;
}

const sizeMap: Record<FlagSize, string> = {
  xs: 'w-4 h-3',
  sm: 'w-5 h-4',
  md: 'w-8 h-6',
  lg: 'w-10 h-7',
  xl: 'w-12 h-9',
};

const Flag: React.FC<FlagProps> = ({ countryCode, code, size = 'md', className = '' }) => {
  const sizeClass = sizeMap[size];
  
  return (
    <div
      className={`fi fi-${countryCode.toLowerCase()} ${sizeClass} overflow-hidden flex-shrink-0 shadow-sm ${className}`}
      title={code || countryCode}
    />
  );
};

export default Flag;
